import { post } from '../../utils/Backend';
import { useLongfansMock } from '../../global/GlobalMock';
import type { CourseBrief, CourseDetail, CourseResourceAccessQuery } from './CourseResourceType';
import { CourseResourceMock } from './CourseResourceMock';

const mock = useLongfansMock && false;

const URL_LIST = '/lark/app/courseResource/listCourses';
const URL_DETAIL = '/lark/app/courseResource/getCourseDetail';
const URL_PROGRESS = '/lark/app/courseResource/reportLessonProgress';
const URL_OPEN = '/lark/app/courseResource/recordCourseOpen';

function unwrap<T>(res: T | string): T {
  if (typeof res === 'string') throw new Error(res);
  return res;
}

/** 课程资源前台 API */
export const CourseResourceApi = {
  async listCourses(query: CourseResourceAccessQuery): Promise<{ courses: CourseBrief[] }> {
    if (mock) return CourseResourceMock.listCourses();
    return unwrap(await post<CourseResourceAccessQuery, { courses: CourseBrief[] }>(URL_LIST, query, { silent: true }));
  },

  async getCourseDetail(query: CourseResourceAccessQuery & { courseId: string }): Promise<CourseDetail> {
    if (mock) return CourseResourceMock.getCourseDetail(query.courseId);
    return unwrap(await post<typeof query, CourseDetail>(URL_DETAIL, query, { silent: true }));
  },

  async reportLessonProgress(
    query: CourseResourceAccessQuery & {
      courseId: string;
      lessonId: string;
      progress: number;
      completed?: boolean;
    },
  ): Promise<{ progress: number; completed: boolean }> {
    if (mock) return CourseResourceMock.reportLessonProgress(query.lessonId, query.progress, query.completed);
    return unwrap(await post<typeof query, { progress: number; completed: boolean }>(URL_PROGRESS, query, { silent: true }));
  },

  async recordCourseOpen(query: CourseResourceAccessQuery & { courseId: string }): Promise<{ learnerCount: number }> {
    if (mock) return CourseResourceMock.recordCourseOpen(query.courseId);
    return unwrap(await post<typeof query, { learnerCount: number }>(URL_OPEN, query, { silent: true }));
  },
};
